module.exports = __webpack_public_path__ + "static/img/cont3609.8cb5b85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3609.jpg
// module id = IIrq
// module chunks = 0